import { useContext } from 'react'

import { UserContext } from '../context'

export const useUserContext = () => {
  const context = useContext(UserContext)

  if (context === undefined) {
    throw new Error('useUserContext can only be used inside UserContextProvider')
  }

  return context
}
